import { ZoomIn } from '@mui/icons-material';
import { Dialog, DialogContent, DialogProps, DialogTitle, IconButton, Stack } from '@mui/material';
import React, { useMemo, useState } from 'react';

interface Props {
  /** The field content */
  children: React.ReactNode;
  /** Only provides the dialog when zoomable=true */
  zoomable?: boolean;
  /** The content inside the dialog */
  content: React.ReactNode;
  /** The dialog title */
  title?: React.ReactNode;
  /** Zoom button position */
  placement?: 'start' | 'end';
}
export default function DialogZoomField({
  title,
  children,
  zoomable,
  content,
  placement,
  ...props
}: Props & Omit<DialogProps, 'title' | 'content' | 'children' | 'open'>): React.JSX.Element {
  const [isOpen, setOpen] = useState<boolean>(false);
  const isZoomable = useMemo(() => zoomable !== false, [zoomable]);
  const _placement = useMemo(() => placement ?? 'start', [placement]);

  const zoomButton = useMemo(
    () => (
      <IconButton
        sx={{ '&:hover': { background: 'transparent', color: 'secondary.main' } }}
        onClick={() => setOpen(true)}
      >
        {<ZoomIn />}
      </IconButton>
    ),
    [],
  );

  if (!isZoomable) {
    return <>{children}</>;
  }

  return (
    <>
      <Dialog
        {...props}
        open={isOpen}
        onClose={(e, r) => {
          if (props.onClose !== undefined) {
            props.onClose(e, r);
          }
          setOpen(false);
        }}
      >
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>{content}</DialogContent>
      </Dialog>
      <Stack
        direction={_placement === 'start' ? 'row' : 'row-reverse'}
        spacing={1}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        {zoomButton}
        {children}
      </Stack>
    </>
  );
}
